export const filterOutTypeName = <T extends { __typename?: string }>({ __typename, ...otherFields }: T): Omit<T, '__typename'> => ({
  ...otherFields
}); 